import { useState } from 'react';
import { Dialog } from '../../../layouts/Dialog';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';

export function LoginDialog() {
  const [isRegisterform, setIsRegisterForm] = useState(false);
  const handleButton = () => {
    setIsRegisterForm(!isRegisterform);
  };

  return (
    <Dialog dialogId="loginDialog">
      <div className="fixed top-[10vh] left-0 right-0 mx-auto grid h-fit w-fit max-w-screen-sm place-items-center overflow-auto rounded-2xl bg-gray-100 px-4 py-3 dark:bg-gray-900">
        {isRegisterform ? <RegisterForm /> : <LoginForm />}
        <button
          onClick={handleButton}
          className="mt-6 mb-3 w-full text-left text-xs hover:text-indigo-600 dark:hover:text-indigo-300"
        >
          {isRegisterform
            ? 'Already registered? login here'
            : "Don't have account? register here"}
        </button>
      </div>
    </Dialog>
  );
}
